if (!customElements.get('icon-features-carousel')) {
  class IconFeaturesCarousel extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.icon-features__list');
      this.section = this.closest('.icon-features');
      if (!this.list || !this.section) return;

      this.prevBtn = this.querySelector('.icon-features__arrow--prev');
      this.nextBtn = this.querySelector('.icon-features__arrow--next');
      this.dotsWrap = this.section.querySelector('.icon-features__dots');
      this.items = Array.from(this.list.children);

      this.buildDots();
      this.bindArrows();
      this.bindScroll();
      this.updateState();

      window.addEventListener('resize', () => this.updateState());
    }

    get isCarouselActive() {
      return (
        window.matchMedia('(max-width: 749px)').matches &&
        this.section.dataset.mobileLayout === 'carousel'
      );
    }

    slideMetrics() {
      const item = this.items[0];
      if (!item) return { width: 0, gap: 0 };
      const rect = item.getBoundingClientRect();
      const style = window.getComputedStyle(this.list);
      const gap = parseFloat(style.columnGap || style.gap || '0');
      return { width: rect.width, gap };
    }

    buildDots() {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      const visible = parseFloat(this.section.style.getPropertyValue('--if-columns-mobile')) ||
        parseFloat(getComputedStyle(this.section).getPropertyValue('--if-columns-mobile')) || 1;
      const groups = Math.max(1, Math.ceil(this.items.length - Math.floor(visible) + 1));
      this.dots = [];
      for (let i = 0; i < groups; i++) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'icon-features__dot';
        dot.setAttribute('aria-label', `Go to item ${i + 1}`);
        dot.addEventListener('click', () => this.scrollToIndex(i));
        this.dotsWrap.appendChild(dot);
        this.dots.push(dot);
      }
    }

    bindArrows() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.step(-1));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.step(1));
      }
    }

    step(direction) {
      const { width, gap } = this.slideMetrics();
      this.list.scrollBy({ left: direction * (width + gap), behavior: 'smooth' });
    }

    scrollToIndex(index) {
      const { width, gap } = this.slideMetrics();
      this.list.scrollTo({ left: index * (width + gap), behavior: 'smooth' });
    }

    bindScroll() {
      let ticking = false;
      this.list.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          this.updateState();
          ticking = false;
        });
      });
    }

    updateState() {
      if (!this.isCarouselActive) {
        if (this.prevBtn) this.prevBtn.disabled = true;
        if (this.nextBtn) this.nextBtn.disabled = true;
        return;
      }

      const { width, gap } = this.slideMetrics();
      const scrollLeft = this.list.scrollLeft;
      const maxScroll = this.list.scrollWidth - this.list.clientWidth;
      const activeIndex = width + gap > 0 ? Math.round(scrollLeft / (width + gap)) : 0;

      if (this.prevBtn) this.prevBtn.disabled = scrollLeft <= 4;
      if (this.nextBtn) this.nextBtn.disabled = scrollLeft >= maxScroll - 4;

      if (this.dots) {
        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === activeIndex ? 'true' : 'false');
        });
      }
    }
  }

  customElements.define('icon-features-carousel', IconFeaturesCarousel);
}